/** New York market close (5pm) — defines the single instant all values are "as of". */
export const VALUE_DATE_NY_HOUR = 17;

/** IANA timezones for each region shown in the data-date tooltip. */
export const DATA_DATE_REGIONS = [
  { label: 'New York', timezone: 'America/New_York' },
  { label: 'London', timezone: 'Europe/London' },
  { label: 'Singapore', timezone: 'Asia/Singapore' },
  { label: 'Sydney', timezone: 'Australia/Sydney' },
] as const;

export const DATA_DATE_FORMAT = 'DD MMM YYYY, HH:mm';
